export const SUPPORTED_LANGUAGES = {
  // Tier 1 — ElevenLabs eleven_v3 (32 languages) + Mongolian (eleven_v3 / local Tsetsen)
  en: 'English',
  ja: 'Japanese',
  zh: 'Chinese',
  de: 'German',
  hi: 'Hindi',
  fr: 'French',
  ko: 'Korean',
  pt: 'Portuguese',
  it: 'Italian',
  es: 'Spanish',
  id: 'Indonesian',
  nl: 'Dutch',
  tr: 'Turkish',
  tl: 'Filipino',
  pl: 'Polish',
  sv: 'Swedish',
  bg: 'Bulgarian',
  ro: 'Romanian',
  ar: 'Arabic',
  cs: 'Czech',
  el: 'Greek',
  fi: 'Finnish',
  hr: 'Croatian',
  ms: 'Malay',
  sk: 'Slovak',
  da: 'Danish',
  ta: 'Tamil',
  uk: 'Ukrainian',
  ru: 'Russian',
  hu: 'Hungarian',
  no: 'Norwegian',
  vi: 'Vietnamese',
  mn: 'Mongolian',
} as const

export type LanguageCode = keyof typeof SUPPORTED_LANGUAGES

export const LANGUAGE_CODES = Object.keys(SUPPORTED_LANGUAGES) as LanguageCode[]

export const DEFAULT_LANGUAGE: LanguageCode = 'en'

// Credit limits
export const FREE_STUDIO_TRIAL_MINUTES = 5    // one-time, not recurring
export const FREE_EXTENSION_TRIAL_MINUTES = 30 // one-time, not recurring
export const MAX_VIDEO_DURATION_SECONDS = 10800 // 3 hours

// Studio minutes included per subscription tier per billing period
export const TIER_STUDIO_MINUTES: Record<string, number> = {
  free:          0,
  ext_basic:     0,
  ext_pro:       0,
  studio_basic:  30,
  studio_pro:    120,
  bundle_basic:  30,
  bundle_pro:    120,
}

// Extension minutes included per subscription tier per billing period
export const TIER_EXTENSION_MINUTES: Record<string, number> = {
  free:          0,
  ext_basic:     300,
  ext_pro:       1000,
  studio_basic:  0,
  studio_pro:    0,
  bundle_basic:  300,
  bundle_pro:    1000,
}

// Storage
export const JOB_RETENTION_DAYS = 30
export const JOB_EXPIRY_WARNING_DAYS = 7
export const UPLOAD_JOB_RETENTION_HOURS = 24
